import { useRef, useState, useEffect } from 'react'

export const useScrollButtons = () => {
    const containerRef = useRef<HTMLDivElement>(null)
    const [canScrollLeft, setCanScrollLeft] = useState(false)
    const [canScrollRight, setCanScrollRight] = useState(false)

    useEffect(() => {
        const container = containerRef.current
        if (!container) return

        const checkScroll = () => {
            const hasOverflow = container.scrollWidth > container.clientWidth
            const isAtStart = Math.abs(container.scrollLeft) <= 0
            const isAtEnd = Math.abs(container.scrollLeft) + container.clientWidth >= container.scrollWidth - 1

            setCanScrollLeft(hasOverflow && !isAtEnd)
            setCanScrollRight(hasOverflow && !isAtStart)
        }

        checkScroll()

        const resizeObserver = new ResizeObserver(checkScroll)
        resizeObserver.observe(container)
        container.addEventListener('scroll', checkScroll, { passive: true })

        return () => {
            resizeObserver.disconnect()
            container.removeEventListener('scroll', checkScroll)
        }
    }, [])

    return { containerRef, canScrollLeft, canScrollRight }
}
